function openBestsellersmb(evted, cityBestsellersmb) {
  var i, tabcontentbestsellersmb, tablinksbestsellersmb;
  tabcontentbestsellersmb = document.getElementsByClassName(
    "tabcontentbestsellersmb"
  );
  for (i = 0; i < tabcontentbestsellersmb.length; i++) {
    tabcontentbestsellersmb[i].style.display = "none";
  }
  tablinksbestsellersmb = document.getElementsByClassName(
    "tablinksbestsellersmb"
  );
  for (i = 0; i < tablinksbestsellersmb.length; i++) {
    tablinksbestsellersmb[i].className = tablinksbestsellersmb[
      i
    ].className.replace(" active", "");
  }
  document.getElementById(cityBestsellersmb).style.display = "block";
  evted.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultBestsellersmb").click();

var swiper = new Swiper(".swiperBestsellers", {
  slidesPerView: 2,
  spaceBetween: 10,
  grid: {
    rows: 2,
    fill: "row",
  },
});
